
import AiButtons from './ai-buttons'
import AiProfileSelect from './ai-profile-select.vue'
import AiMultiselect from './ai-multiselect.vue'
import AiSelect from './ai-select.vue'
import AiText from './ai-text.vue'
import AiVerticalSelect from './ai-vertical-select.vue'

export default {
  components: {AiButtons, AiMultiselect, AiSelect, AiText, AiProfileSelect, AiVerticalSelect},
  props: {
    input: {type: Object, required: true},
    answer: {type: Object, default: undefined},
    disabled: {type: Boolean, default: false}
  },
  emits: ['prompt'],
  computed: {
    type() {
      return this.input.type
    },
    items() {
      return this.input.items
    },
    skip() {
      return this.input.skip
    },
    skip_all() {
      return this.input.skip_all
    },
    chat_query() {
      return this.input.chat_query
    }
  }
}
